import React from "react";
import PolicyPage, { ContactEmail } from "./PolicyPage";

function LegalNotice() {
  return (
    <PolicyPage title="Legal Notice">
      <h2>Website operator</h2>
      <p>This online store operates under the brand name <strong>camartzuno</strong>. The current postal contact address appears in the site footer.</p>

      <h2>Contact</h2>
      <p>Email: <ContactEmail /></p>

      <h2>Customer service</h2>
      <p>When contacting us about a purchase, include the order number but do not send passwords, complete card numbers, or unnecessary identity documents by email.</p>

      <h2>Editorial responsibility</h2>
      <p>camartzuno is responsible for the original store content published on this site. Product information may also reflect specifications supplied by manufacturers or other providers and is reviewed and adapted for this store.</p>

      <h2>Consumer information</h2>
      <p>Prices, key product characteristics, payment, delivery, cancellation, and return information are presented on the relevant product, checkout, and policy pages. Mandatory consumer rights in your country of residence remain unaffected.</p>

      <h2>Notices</h2>
      <p>Legal, privacy, accessibility, and intellectual-property notices may be sent to <ContactEmail />. Please identify the type of notice in the subject line so it can be routed appropriately.</p>
    </PolicyPage>
  );
}

export default LegalNotice;
